import { render } from "./verify-email.vue?vue&type=template&id=cca9c8ca&scoped=true"
import script from "./verify-email.vue?vue&type=script&lang=js"
export * from "./verify-email.vue?vue&type=script&lang=js"

import "./verify-email.vue?vue&type=style&index=0&id=cca9c8ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca9c8ca"]])

export default __exports__